module.exports = __webpack_public_path__ + "static/media/website.4e988c8a.svg";